/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import TwoFactorNudgeViewComponent from './view';

import UserService from 'services/UserService';
import NotificationHelper from 'lib/notifications';

import { ROLE_BUYER, ROLE_SELLER } from 'constants/companyRoles';
import { PROTECTED_BUYER_DASHBOARD, PROTECTED_SELLER_DASHBOARD } from 'constants/pageRoutes';

type TwoFactorNudgeComponentProps = {
  activeCompanyRole: number;
}

type TwoFactorNudgeComponentState = {
  loaded: boolean;
  qrActivated: boolean;
  smsActivated: boolean;
  dialogOpen: boolean;
}

class TwoFactorNudgeComponent extends React.Component<TwoFactorNudgeComponentProps, TwoFactorNudgeComponentState> {

  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      qrActivated: false,
      smsActivated: false,
      dialogOpen: false
    };
  }

  isSellerOrBuyer = () =>
    this.props.activeCompanyRole === ROLE_SELLER || this.props.activeCompanyRole === ROLE_BUYER;

  componentDidMount = async () => {
    if (!this.isSellerOrBuyer()) return;

    try {
      const ts = await UserService.getTwoFactorState();
      this.setState({ loaded: true, qrActivated: !!ts.qrActivated, smsActivated: !!ts.smsActivated });
    } catch (e) {
      console.error(e);
    }
  }

  openDialog = () => this.setState({ dialogOpen: true });

  closeDialog = () => this.setState({ dialogOpen: false });

  completeSetup = async () => {
    try {
      await UserService.notifyTwoFactorUpdated();
    } catch (e) {
      console.error(e);
    }

    try {
      const ts = await UserService.getTwoFactorState();
      this.setState({ qrActivated: !!ts.qrActivated, smsActivated: !!ts.smsActivated, dialogOpen: false });
      NotificationHelper.createNotification(NotificationHelper.TYPE_SUCCESS, 'notifications.2fa.success');
    } catch (e) {
      console.error(e);
      this.setState({ dialogOpen: false });
    }
  }

  render() {
    if (!this.isSellerOrBuyer()) return null;
    if (!this.state.loaded) return null;
    if (this.state.qrActivated || this.state.smsActivated) return null;

    const pathname = this.props.location.pathname;
    if (pathname !== PROTECTED_SELLER_DASHBOARD && pathname !== PROTECTED_BUYER_DASHBOARD) return null;

    return (
      <TwoFactorNudgeViewComponent
        dialogOpen={this.state.dialogOpen}
        openDialog={this.openDialog}
        closeDialog={this.closeDialog}
        completeSetup={this.completeSetup}
      />
    );
  }
}

const mapStateToProps = state => ({
  activeCompanyRole: state.auth.user.activeCompany.role
});

export default withRouter(connect(mapStateToProps)(TwoFactorNudgeComponent));
